module.exports = __webpack_public_path__ + "img/sbl0013.2061d692.png";